import { createStore } from "vuex";
import tenancyStore from "@devcentre/tenancy-components/src/store/module.js";

export default createStore({
  modules: {
    tenancy: tenancyStore,
  },
  getters: {
    // Forwarding getters so existing views don't need changing
    currentUser: (_state, getters) => getters["tenancy/currentUser"],
    currentTenant: (_state, getters) => getters["tenancy/currentTenant"],
    currentPlan: (_state, getters) => {
      const user = getters["tenancy/currentUser"];
      return user?.products?.find((p) => p.app === "di")?.level ?? "basic";
    },
    hasActiveSubscription: (_state, getters) => {
      const user = getters["tenancy/currentUser"];
      return user?.products?.some((p) => p.app === "di") ?? false;
    },
  },
});
